import { LoginHintJwtEncryptedKey } from "@idw-types/common/login-hint-jwt-encrypted-key";

const key2pem = (keydata: ArrayBuffer) => {
    let body = window.btoa(String.fromCharCode(...new Uint8Array(keydata)));
    body = body.match(/.{1,64}/g).join('\n');
    return body;
}

const getGenKeyParams = (alg: string) => {
    if (alg.startsWith('RS') || alg.startsWith('PS')) return {
        name: "RSASSA-PKCS1-v1_5", // this name also works for RSA-PSS !
        modulusLength: 2048, //can be 1024, 2048, or 4096
        publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
        hash: { name: "SHA-256" }
    };

    throw new Error('invalid key flavor');

}

const getKeyUse = (alg: string): Array<KeyUsage> => (alg.startsWith('ECDH')) ? ['deriveKey', 'deriveBits'] : ['sign', 'verify'];

export const getJWTKeys = async (): Promise<LoginHintJwtEncryptedKey> => {
    const alg = "RSA-OAEP-256";
    // this works with either EC or RSA key types
    const keyUse = getKeyUse(alg);
    const isExtractable = true;
    const genKeyParams = getGenKeyParams(alg);

    try {
        const key = await window.crypto.subtle.generateKey(genKeyParams, isExtractable, keyUse);
        const publicKeyData = await window.crypto.subtle.exportKey("spki", key.publicKey);
        const publicKey = key2pem(publicKeyData);

        const privateKeyData = await window.crypto.subtle.exportKey("pkcs8", key.privateKey);
        const privateKey = key2pem(privateKeyData);

        return { publicKey, privateKey };
    } catch (error) {
        console.error(`Error Generating JWT Encrypted key:`, error);
        return null;
    }
}